module.exports = __webpack_public_path__ + "static/media/Pit Pay One Line.973484f8.svg";